import {
  AllSubscriptionStatus,
  B2CSubscriptionStatus,
  SubscriptionStatus,
} from '../types/types';
import { SiteConfig } from './SiteConfig';

const subscriptionStatusesToPagesMap: Record<
  string,
  { b2c: B2CSubscriptionStatus[]; default: SubscriptionStatus[] }
> = {
  checkout: {
    b2c: [
      B2CSubscriptionStatus.CREATED,
      B2CSubscriptionStatus.ACTIVE,
      B2CSubscriptionStatus.PENDING_RENEWAL,
      B2CSubscriptionStatus.PENDING_CANCELLATION,
      B2CSubscriptionStatus.PAYMENT_FAILED,
      B2CSubscriptionStatus.CANCELLED,
    ],
    default: [
      SubscriptionStatus.Active,
      SubscriptionStatus.Cancelling,
      SubscriptionStatus.Created,
      SubscriptionStatus.Fulfilled,
    ],
  },
  subscription: {
    b2c: [
      B2CSubscriptionStatus.ACTIVE,
      B2CSubscriptionStatus.PENDING_RENEWAL,
      B2CSubscriptionStatus.PENDING_CANCELLATION,
      B2CSubscriptionStatus.CANCELLED,
      B2CSubscriptionStatus.PAYMENT_FAILED,
    ],
    default: [
      SubscriptionStatus.Active,
      SubscriptionStatus.Cancelling,
      SubscriptionStatus.Placed,
      SubscriptionStatus.Paid,
    ],
  },
};

export const getSubscriptionStatuses = (
  page: 'checkout' | 'subscription'
): AllSubscriptionStatus[] => {
  const { isB2CSite } = SiteConfig.getConfig();

  return isB2CSite
    ? subscriptionStatusesToPagesMap[page].b2c
    : subscriptionStatusesToPagesMap[page].default;
};
